import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import NumberSearchInput from './NumberSearchInput'
import SearchField from './SearchField'
import { useState, useEffect, useRef } from 'react'
import useBarcodeScanner from 'components/Sell/hook/useBarcodeScanner'
import CallerIdButton from 'components/Sell/CustomerSellPopup/CallerIdButton/CallerIdButton'

const SEARCH_TEXT = 'common.search'
type IProps = {
    value: string
    onChange: (value: string) => void
    delay?: number
    maxWidth?: string
    placeHolder?: string
    useNumpad?: boolean
    useCallerId?: boolean
    size?: undefined | 'medium'
    searchInputVariant?: 'outlined' | 'filled'
    onBarcodeScanned?: (barcode: string) => void
    autoFocusOnBarcodeScanned?: boolean
}

function DataTableSearchField(props: IProps) {
    const {
        value,
        onChange,
        delay,
        placeHolder = SEARCH_TEXT,
        useNumpad = false,
        useCallerId = false,
        size,
        searchInputVariant,
        onBarcodeScanned,
        autoFocusOnBarcodeScanned = false,
    } = props
    const { t } = useTranslation()
    const [localValue, setLocalValue] = useState(value)

    const handleField = (text: string) => {
        setLocalValue(text)
        onChange(text)
    }
    const searchFieldRef = useRef<HTMLElement | null>(null)
    useEffect(() => {
        if (localValue !== value) setLocalValue(value)
    }, [localValue, value])

    useBarcodeScanner({
        handleAction: (code) => {
            if (autoFocusOnBarcodeScanned) {
                searchFieldRef.current?.focus()
                onBarcodeScanned?.(code)
            }
        },
    })

    return (
        <Box width={'100%'} alignItems={'center'} display={'inline-flex'}>
            <SearchField
                searchInputVariant={searchInputVariant}
                delay={delay}
                size={size}
                placeholder={t(placeHolder)}
                initValue={localValue}
                searchValue={handleField}
                onClear={() => {
                    handleField('')
                }}
                clearable
                inputRef={searchFieldRef}
            />

            {useNumpad && (
                <NumberSearchInput size={size} onSubmit={handleField} />
            )}

            {useCallerId && <CallerIdButton onSubmit={handleField} />}
        </Box>
    )
}

export default DataTableSearchField
